module.exports = __webpack_public_path__ + "static/media/pierre-schneider.d4ef38fc.jpeg";